export async function loadTestimonialPosts() {
  try {
    const response = await fetch('/data/testimonial/index.json');
    if (!response.ok) throw new Error('Failed to fetch testimonial index');
    const testimonialFiles = await response.json();

    const posts = await Promise.all(
      testimonialFiles.map(async (filename) => {
        const response = await fetch(`/data/testimonial/${filename}`);
        if (!response.ok) throw new Error(`Failed to fetch ${filename}`);
        const text = await response.text();
        
        // Split the markdown content
        const [frontMatter, ...contentParts] = text.split('---').filter(Boolean);
        const content = contentParts.join('---').trim();
        
        // Parse the front matter
        const attributes = {};
        frontMatter.split('\n').forEach(line => {
          if (line.includes(':')) {
            const [key, ...valueParts] = line.split(':');
            const trimmedKey = key.trim();
            if (trimmedKey === 'attributes') return;
            
            // Remove quotes if they exist
            const value = valueParts.join(':').trim().replace(/^"(.*)"$/, '$1');
            if (value) attributes[trimmedKey] = value;
          }
        });

        const slug = filename.replace('.md', '');
        
        return {
          slug,
          ...attributes,
          content
        };
      })
    );

    return posts;
  } catch (error) {
    console.error('Error loading testimonial posts:', error);
    return [];
  }
}